module.exports = "/static/assets/5497c727cab01a0290a73b1ff94997ee.png";